module.exports = __webpack_public_path__ + "img/1556714789.6067cd2b.jpg";